import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "lists-page" };
const _hoisted_2 = { class: "lists-layout" };
const _hoisted_3 = { class: "lists-list-panel" };
const _hoisted_4 = { class: "list-selector" };
const _hoisted_5 = ["value"];
const _hoisted_6 = {
    key: 0,
    class: "list-meta"
};
const _hoisted_7 = { class: "item-count" };
const _hoisted_8 = {
    key: 1,
    class: "search-box"
};
const _hoisted_9 = { class: "items-list" };
const _hoisted_10 = {
    key: 0,
    class: "item-items"
};
const _hoisted_11 = ["onClick"];
const _hoisted_12 = {
    key: 1,
    class: "empty-state"
};
const _hoisted_13 = {
    key: 2,
    class: "empty-state welcome"
};
const _hoisted_14 = { class: "item-details-panel" };
const _hoisted_15 = {
    key: 0,
    class: "details-content"
};
const _hoisted_16 = {
    key: 0,
    class: "detail-header"
};
const _hoisted_17 = {
    key: 1,
    class: "detail-header new-item"
};
const _hoisted_18 = { class: "top-actions" };
const _hoisted_19 = { class: "form-fields" };
const _hoisted_20 = {
    key: 0,
    class: "checkbox-field"
};
const _hoisted_21 = ["onUpdate:modelValue"];
const _hoisted_22 = {
    key: 1,
    class: "image-field"
};
const _hoisted_23 = ["onUpdate:modelValue"];
const _hoisted_24 = ["src"];
const _hoisted_25 = ["onUpdate:modelValue"];
const _hoisted_26 = {
    key: 1,
    class: "empty-state"
};
const _hoisted_27 = { class: "modal-header" };
const _hoisted_28 = { class: "modal-body" };
const _hoisted_29 = { class: "modal-footer" };
import { ref, computed } from 'vue';
import { useAdmin } from '@/composables/useAdmin';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ListsPage',
    setup(__props) {
        const admin = useAdmin();
        const selectedListType = ref(null);
        const list = ref(null);
        const selectedItem = ref(null);
        const search = ref('');
        const showDeleteConfirm = ref(false);
        const showSuccessToast = ref(false);
        const successMessage = ref('');
        const showErrorToast = ref(false);
        const errorMessage = ref('');
        const listOptions = ref([
            { route: 'InsuranceProviders', displayName: 'Insurance Providers', editOnly: false },
            { route: 'InvestmentProviders', displayName: 'Investment Providers', editOnly: false },
            { route: 'CreditProviders', displayName: 'Credit Providers', editOnly: false },
            { route: 'InvestmentTypes', displayName: 'Investment Types', editOnly: false },
            { route: 'CreditTypes', displayName: 'Credit Types', editOnly: false },
            { route: 'PolicyTypes', displayName: 'Insurance Policy Types', editOnly: false },
            { route: 'Banks', displayName: 'Banks', editOnly: false },
            { route: 'BankAccountTypes', displayName: 'Bank Account Types', editOnly: true }
        ]);
        const filteredList = computed(() => {
            if (!list.value)
                return null;
            if (!search.value || !search.value.trim())
                return list.value;
            const query = search.value.toLowerCase();
            return list.value.filter((item) => item.name && item.name.toLowerCase().includes(query));
        });
        function formatLabel(key) {
            return key.charAt(0).toUpperCase() + key.slice(1).replace(/([A-Z])/g, ' $1');
        }
        function isBoolean(value) {
            return value === true || value === false;
        }
        function isImageField(key) {
            const lower = key.toLowerCase();
            return lower.includes('logo') || lower.includes('image') || lower.includes('icon');
        }
        function showToast(message) {
            successMessage.value = message;
            showSuccessToast.value = true;
        }
        function showError(message) {
            errorMessage.value = message || "Sorry, that didn't work. Please contact tech.";
            showErrorToast.value = true;
        }
        function onListTypeChanged() {
            selectedItem.value = null;
            search.value = '';
            loadList(true);
        }
        function loadList(autoSelect) {
            if (!selectedListType.value)
                return;
            admin.adminGet('/' + selectedListType.value.route, (result) => {
                list.value = result;
                if (autoSelect && list.value && list.value.length > 0) {
                    selectItem(list.value[0]);
                }
            });
        }
        function selectItem(item) {
            selectedItem.value = item;
        }
        function newItemPressed() {
            const newItem = {};
            if (list.value && list.value.length > 0) {
                for (const key in list.value[0]) {
                    if (key.toLowerCase() !== 'id') {
                        const sample = list.value[0][key];
                        if (sample === true || sample === false) {
                            newItem[key] = false;
                        }
                        else {
                            newItem[key] = '';
                        }
                    }
                }
                newItem.name = 'New Item';
                newItem.id = '';
            }
            list.value.splice(0, 0, newItem);
            selectItem(newItem);
        }
        function cancelNewItem() {
            list.value.splice(0, 1);
            if (list.value.length > 0) {
                selectItem(list.value[0]);
            }
            else {
                selectedItem.value = null;
            }
        }
        function saveItem() {
            if (!selectedItem.value || !selectedListType.value)
                return;
            const route = selectedListType.value.route;
            if (selectedItem.value.id === '') {
                const data = { ...selectedItem.value };
                delete data.id;
                admin.http().post(admin.getApi() + '/' + route, data)
                    .then((result) => {
                    selectItem(result.data);
                    loadList(false);
                    showToast('Item created successfully');
                })
                    .catch(() => { showError(); });
            }
            else {
                admin.http().put(admin.getApi() + '/' + route + '/' + selectedItem.value.id, selectedItem.value)
                    .then((result) => {
                    selectItem(result.data);
                    loadList(false);
                    showToast('Item saved successfully');
                })
                    .catch(() => { showError(); });
            }
        }
        function deleteItem() {
            if (!selectedItem.value || !selectedListType.value)
                return;
            admin.adminDelete('/' + selectedListType.value.route + '/' + selectedItem.value.id, () => {
                showDeleteConfirm.value = false;
                selectedItem.value = null;
                loadList(true);
                showToast('Item deleted successfully');
            });
        }
        return (_ctx, _cache) => {
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_snackbar = _resolveComponent("v-snackbar");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "list-header" }, [
                            _createElementVNode("h2", null, "Lists")
                        ], -1)),
                        _createElementVNode("div", _hoisted_4, [
                            _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((selectedListType).value = $event)),
                                class: "form-input",
                                onChange: onListTypeChanged
                            }, [
                                _cache[12] || (_cache[12] = _createElementVNode("option", {
                                    value: null,
                                    disabled: ""
                                }, "Select a list...", -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listOptions.value, (opt) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                        key: opt.route,
                                        value: opt
                                    }, _toDisplayString(opt.displayName), 9, _hoisted_5));
                                }), 128))
                            ], 544), [
                                [_vModelSelect, selectedListType.value]
                            ])
                        ]),
                        (selectedListType.value && list.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                _createElementVNode("span", _hoisted_7, _toDisplayString(list.value.length) + " " + _toDisplayString(selectedListType.value.displayName), 1),
                                (!selectedListType.value.editOnly)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        class: "action-btn primary small",
                                        onClick: newItemPressed
                                    }, "+ New"))
                                    : _createCommentVNode("", true)
                            ]))
                            : _createCommentVNode("", true),
                        (selectedListType.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((search).value = $event)),
                                    type: "text",
                                    placeholder: "Search items...",
                                    class: "search-input"
                                }, null, 512), [
                                    [_vModelText, search.value]
                                ])
                            ]))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_9, [
                            (filteredList.value && filteredList.value.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredList.value, (item) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            key: item.id || item.name,
                                            class: _normalizeClass(["item-row", { active: selectedItem.value && selectedItem.value === item }]),
                                            onClick: ($event) => (selectItem(item))
                                        }, _toDisplayString(item.name), 11, _hoisted_11));
                                    }), 128))
                                ]))
                                : (selectedListType.value && list.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, " No items found "))
                                    : (!selectedListType.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, " Select a list to get started "))
                                        : _createCommentVNode("", true)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                        (selectedItem.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                (selectedItem.value.id)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(selectedItem.value.id), 1))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_17, " New Item ")),
                                _createElementVNode("div", _hoisted_18, [
                                    _createElementVNode("button", {
                                        class: "action-btn primary",
                                        onClick: saveItem
                                    }, _toDisplayString(selectedItem.value.id ? 'Save Changes' : 'Create Item'), 1),
                                    (selectedItem.value.id && !selectedListType.value.editOnly)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            class: "action-btn danger",
                                            onClick: _cache[2] || (_cache[2] = ($event) => (showDeleteConfirm.value = true))
                                        }, "Delete"))
                                        : _createCommentVNode("", true),
                                    (!selectedItem.value.id)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 1,
                                            class: "action-btn secondary",
                                            onClick: cancelNewItem
                                        }, "Cancel"))
                                        : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_19, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedItem.value, (value, key) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            key: key,
                                            class: "form-group"
                                        }, [
                                            (key !== 'id')
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                    _createElementVNode("label", null, _toDisplayString(formatLabel(key)), 1),
                                                    (isBoolean(selectedItem.value[key]))
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                                            _withDirectives(_createElementVNode("input", {
                                                                "onUpdate:modelValue": ($event) => ((selectedItem.value[key]) = $event),
                                                                type: "checkbox",
                                                                class: "form-checkbox"
                                                            }, null, 8, _hoisted_21), [
                                                                [_vModelCheckbox, selectedItem.value[key]]
                                                            ])
                                                        ]))
                                                        : (isImageField(key))
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                                                _withDirectives(_createElementVNode("input", {
                                                                    "onUpdate:modelValue": ($event) => ((selectedItem.value[key]) = $event),
                                                                    type: "text",
                                                                    class: "form-input"
                                                                }, null, 8, _hoisted_23), [
                                                                    [_vModelText, selectedItem.value[key]]
                                                                ]),
                                                                (selectedItem.value[key])
                                                                    ? (_openBlock(), _createElementBlock("img", {
                                                                        key: 0,
                                                                        src: selectedItem.value[key],
                                                                        class: "field-image-preview",
                                                                        onError: _cache[3] || (_cache[3] = ($event) => ($event.target.style.display = 'none'))
                                                                    }, null, 40, _hoisted_24))
                                                                    : _createCommentVNode("", true)
                                                            ]))
                                                            : _withDirectives((_openBlock(), _createElementBlock("input", {
                                                                key: 2,
                                                                "onUpdate:modelValue": ($event) => ((selectedItem.value[key]) = $event),
                                                                type: "text",
                                                                class: "form-input"
                                                            }, null, 8, _hoisted_25)), [
                                                                [_vModelText, selectedItem.value[key]]
                                                            ])
                                                ], 64))
                                                : _createCommentVNode("", true)
                                        ]));
                                    }), 128))
                                ])
                            ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(selectedListType.value ? 'Select an item to view details' : 'Select a list to get started'), 1))
                    ])
                ]),
                (showDeleteConfirm.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "modal-overlay",
                        onClick: _cache[7] || (_cache[7] = ($event) => (showDeleteConfirm.value = false))
                    }, [
                        _createElementVNode("div", {
                            class: "modal-dialog",
                            onClick: _cache[6] || (_cache[6] = _withModifiers(() => { }, ["stop"]))
                        }, [
                            _createElementVNode("div", _hoisted_27, [
                                _cache[14] || (_cache[14] = _createElementVNode("h3", null, "Delete Item", -1)),
                                _createElementVNode("button", {
                                    class: "close-btn",
                                    onClick: _cache[4] || (_cache[4] = ($event) => (showDeleteConfirm.value = false))
                                }, "✕")
                            ]),
                            _createElementVNode("div", _hoisted_28, [
                                _createElementVNode("p", null, [
                                    _cache[15] || (_cache[15] = _createTextVNode("Are you sure you want to delete ")),
                                    _createElementVNode("strong", null, _toDisplayString(selectedItem.value.name), 1),
                                    _cache[16] || (_cache[16] = _createTextVNode("?"))
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_29, [
                                _createElementVNode("button", {
                                    class: "action-btn danger",
                                    onClick: deleteItem
                                }, "Delete"),
                                _createElementVNode("button", {
                                    class: "action-btn secondary",
                                    onClick: _cache[5] || (_cache[5] = ($event) => (showDeleteConfirm.value = false))
                                }, "Cancel")
                            ])
                        ])
                    ]))
                    : _createCommentVNode("", true),
                _createVNode(_component_v_snackbar, {
                    modelValue: showSuccessToast.value,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((showSuccessToast).value = $event)),
                    timeout: 3000,
                    location: "bottom",
                    color: "success"
                }, {
                    actions: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                            icon: "mdi-close",
                            size: "small",
                            onClick: _cache[8] || (_cache[8] = ($event) => (showSuccessToast.value = false))
                        })
                    ]),
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(successMessage.value) + " ", 1)
                    ]),
                    _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_v_snackbar, {
                    modelValue: showErrorToast.value,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((showErrorToast).value = $event)),
                    timeout: 4000,
                    location: "bottom",
                    color: "error"
                }, {
                    actions: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                            icon: "mdi-close",
                            size: "small",
                            onClick: _cache[10] || (_cache[10] = ($event) => (showErrorToast.value = false))
                        })
                    ]),
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(errorMessage.value) + " ", 1)
                    ]),
                    _: 1
                }, 8, ["modelValue"])
            ]));
        };
    }
});
